import { render, staticRenderFns } from "./ItemLoader.vue?vue&type=template&id=ebce1b24&scoped=true&"
import script from "./ItemLoader.vue?vue&type=script&lang=js&"
export * from "./ItemLoader.vue?vue&type=script&lang=js&"
import style0 from "./ItemLoader.vue?vue&type=style&index=0&id=ebce1b24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebce1b24",
  null
  
)

export default component.exports